var _class, _AddData;
import "core-js/modules/es.symbol.description.js";
import "core-js/modules/es.promise.finally.js";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
import { observer } from "mobx-react";
import { runInAction } from "mobx";
import PropTypes from "prop-types";
import { Component } from "react";
import { Trans, withTranslation } from "react-i18next";
import { Category, DatatabAction } from "../../../../Core/AnalyticEvents/analyticEvents";
import getDataType from "../../../../Core/getDataType";
import TimeVarying from "../../../../ModelMixins/TimeVarying";
import addUserCatalogMember from "../../../../Models/Catalog/addUserCatalogMember";
import addUserFiles from "../../../../Models/Catalog/addUserFiles";
import CatalogMemberFactory from "../../../../Models/Catalog/CatalogMemberFactory";
import createCatalogItemFromFileOrUrl from "../../../../Models/Catalog/createCatalogItemFromFileOrUrl";
import CommonStrata from "../../../../Models/Definition/CommonStrata";
import upsertModelFromJson from "../../../../Models/Definition/upsertModelFromJson";
import Icon from "../../../../Styled/Icon";
import Dropdown from "../../../Generic/Dropdown";
import Loader from "../../../Loader";
import Styles from "./add-data.scss";
import FileInput from "./FileInput";
import { parseCustomMarkdownToReactWithOptions } from "../../../Custom/parseCustomMarkdownToReact";
import loadJson from "../../../../Core/loadJson";
import TerriaError from "../../../../Core/TerriaError";

/**
 * Add data panel in modal window -> My data tab
 */
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
let AddData = observer(_class = (_AddData = class AddData extends Component {
  constructor(props) {
    var _this$props$remoteDat, _this$props$localData;
    super(props);
    const remoteDataTypes = (_this$props$remoteDat = this.props.remoteDataTypes) !== null && _this$props$remoteDat !== void 0 ? _this$props$remoteDat : getDataType().remoteDataType;

    // Automatically suffix supported extension types to localDataType names
    const localDataTypes = ((_this$props$localData = this.props.localDataTypes) !== null && _this$props$localData !== void 0 ? _this$props$localData : getDataType().localDataType).map(dataType => {
      var _dataType$extensions;
      const extensions = (_dataType$extensions = dataType.extensions) !== null && _dataType$extensions !== void 0 && _dataType$extensions.length ? " (".concat(buildExtensionsList(dataType.extensions), ")") : "";
      return _objectSpread(_objectSpread({}, dataType), {}, {
        name: "".concat(dataType.name).concat(extensions)
      });
    });
    this.state = {
      remoteDataTypes,
      localDataTypes,
      localDataType: localDataTypes[0],
      remoteUrl: "",
      // By default there's no remote url
      isLoading: false
    };
  }
  selectLocalOption(option) {
    this.setState({
      localDataType: option
    });
  }
  selectRemoteOption(option) {
    runInAction(() => {
      this.props.viewState.remoteDataType = option;
    });
  }
  handleUploadFile(e) {
    this.setState({
      isLoading: true
    });
    addUserFiles(e.target.files, this.props.terria, this.props.viewState, this.state.localDataType).then(addedCatalogItems => {
      if (addedCatalogItems && addedCatalogItems.length > 0) {
        this.props.onFileAddFinished(addedCatalogItems);
      }
      this.setState({
        isLoading: false
      });
      // reset active tab when file handling is done
      this.props.resetTab();
    });
  }
  async handleUrl(e) {
    var _this$props$terria$an;
    const url = this.state.remoteUrl;
    e.preventDefault();
    (_this$props$terria$an = this.props.terria.analytics) === null || _this$props$terria$an === void 0 || _this$props$terria$an.logEvent(Category.dataTab, DatatabAction.addDataUrl, url);
    this.setState({
      isLoading: true
    });
    let promise;
    if (!this.props.viewState.remoteDataType || this.props.viewState.remoteDataType.value === "auto") {
      var _this$props$viewState;
      promise = createCatalogItemFromFileOrUrl(this.props.terria, this.state.remoteUrl, (_this$props$viewState = this.props.viewState.remoteDataType) === null || _this$props$viewState === void 0 ? void 0 : _this$props$viewState.value);
    } else if (this.props.viewState.remoteDataType.value === "json") {
      promise = loadJson(this.state.remoteUrl).then(data => {
        if (data.error) {
          return Promise.reject(data.error);
        }
        this.props.terria.catalog.group.addMembersFromJson(CommonStrata.user, data.catalog).raiseError(this.props.terria, "Failed to load catalog from file");
      }).then(() => {
        this.props.onUrlAddFinished();
      }).catch(error => TerriaError.from(error).raiseError(this.props.terria, "An error occurred trying to add data from URL: ".concat(this.state.remoteUrl))).finally(() => {
        this.setState({
          isLoading: false
        });
      });
    } else {
      try {
        const newItem = upsertModelFromJson(CatalogMemberFactory, this.props.terria, "", CommonStrata.defaults, {
          type: this.props.viewState.remoteDataType.value,
          name: url
        }, {}).throwIfUndefined({
          message: "An error occurred trying to add data from URL: ".concat(url)
        });
        newItem.setTrait(CommonStrata.user, "url", url);
        promise = newItem.loadMetadata().then(result => {
          if (result.error) {
            return Promise.reject(result.error);
          }
          return Promise.resolve(newItem);
        });
      } catch (e) {
        promise = Promise.reject(e);
      }
    }
    addUserCatalogMember(this.props.terria, promise).then(addedItem => {
      if (addedItem) {
        this.props.onFileAddFinished([addedItem]);
        if (TimeVarying.is(addedItem)) {
          this.props.terria.timelineStack.addToTop(addedItem);
        }
      }

      // FIXME: Setting state here might result in a react warning if the
      // component unmounts before the promise finishes
      this.setState({
        isLoading: false
      });
      this.props.resetTab();
    });
  }
  onRemoteUrlChange(event) {
    this.setState({
      remoteUrl: event.target.value
    });
  }
  renderPanels() {
    var _this$props$viewState2, _this$state$localData, _this$state$localData2;
    const {
      t
    } = this.props;
    const dropdownTheme = {
      dropdown: Styles.dropdown,
      list: Styles.dropdownList,
      isOpen: Styles.dropdownListIsOpen,
      icon: /*#__PURE__*/_jsx(Icon, {
        glyph: Icon.GLYPHS.opened
      })
    };
    const dataTypes = this.state.localDataTypes.reduce(function (result, currentDataType) {
      if (currentDataType.extensions) {
        return result.concat(currentDataType.extensions.map(extension => "." + extension));
      } else {
        return result;
      }
    }, []);
    const remoteDataType = (_this$props$viewState2 = this.props.viewState.remoteDataType) !== null && _this$props$viewState2 !== void 0 ? _this$props$viewState2 : this.state.remoteDataTypes[0];
    return /*#__PURE__*/_jsxs("div", {
      className: Styles.tabPanels,
      children: [this.props.activeTab === "local" && /*#__PURE__*/_jsxs(_Fragment, {
        children: [/*#__PURE__*/_jsx("div", {
          className: Styles.tabHeading,
          children: t("addData.localAdd")
        }), /*#__PURE__*/_jsxs("section", {
          className: Styles.tabPanel,
          children: [/*#__PURE__*/_jsx("label", {
            className: Styles.label,
            children: /*#__PURE__*/_jsxs(Trans, {
              i18nKey: "addData.localFileType",
              children: [/*#__PURE__*/_jsx("strong", {
                children: "Step 1:"
              }), " Select file type"]
            })
          }), /*#__PURE__*/_jsx(Dropdown, {
            options: this.state.localDataTypes,
            selected: this.state.localDataType,
            selectOption: this.selectLocalOption.bind(this),
            matchWidth: true,
            theme: dropdownTheme
          }), (_this$state$localData = this.state.localDataType) !== null && _this$state$localData !== void 0 && _this$state$localData.description ? parseCustomMarkdownToReactWithOptions((_this$state$localData2 = this.state.localDataType) === null || _this$state$localData2 === void 0 ? void 0 : _this$state$localData2.description) : null, /*#__PURE__*/_jsx("label", {
            className: Styles.label,
            children: /*#__PURE__*/_jsxs(Trans, {
              i18nKey: "addData.localFile",
              children: [/*#__PURE__*/_jsx("strong", {
                children: "Step 2:"
              }), " Select file"]
            })
          }), /*#__PURE__*/_jsx(FileInput, {
            accept: dataTypes.join(","),
            onChange: this.handleUploadFile.bind(this)
          }), this.state.isLoading && /*#__PURE__*/_jsx(Loader, {})]
        })]
      }), this.props.activeTab === "web" && /*#__PURE__*/_jsxs(_Fragment, {
        children: [/*#__PURE__*/_jsx("div", {
          className: Styles.tabHeading,
          children: t("addData.webAdd")
        }), /*#__PURE__*/_jsxs("section", {
          className: Styles.tabPanel,
          children: [/*#__PURE__*/_jsx("label", {
            className: Styles.label,
            children: /*#__PURE__*/_jsxs(Trans, {
              i18nKey: "addData.webFileType",
              children: [/*#__PURE__*/_jsx("strong", {
                children: "Step 1:"
              }), " Select file or web service type"]
            })
          }), /*#__PURE__*/_jsx(Dropdown, {
            options: this.state.remoteDataTypes,
            selected: remoteDataType,
            selectOption: this.selectRemoteOption.bind(this),
            matchWidth: true,
            theme: dropdownTheme
          }), remoteDataType !== null && remoteDataType !== void 0 && remoteDataType.description ? parseCustomMarkdownToReactWithOptions(remoteDataType === null || remoteDataType === void 0 ? void 0 : remoteDataType.description) : null, remoteDataType !== null && remoteDataType !== void 0 && remoteDataType.customComponent ? this.renderCustomComponent(remoteDataType === null || remoteDataType === void 0 ? void 0 : remoteDataType.customComponent) : this.renderDefaultForWebDataType(t)]
        })]
      })]
    });
  }
  renderCustomComponent(CustomComponent) {
    return /*#__PURE__*/_jsx(CustomComponent, {});
  }
  renderDefaultForWebDataType(t) {
    return /*#__PURE__*/_jsxs(_Fragment, {
      children: [/*#__PURE__*/_jsx("label", {
        className: Styles.label,
        children: /*#__PURE__*/_jsxs(Trans, {
          i18nKey: "addData.webFile",
          children: [/*#__PURE__*/_jsx("strong", {
            children: "Step 2:"
          }), " Enter the URL of the data file or web service"]
        })
      }), /*#__PURE__*/_jsxs("form", {
        className: Styles.urlInput,
        children: [/*#__PURE__*/_jsx("input", {
          value: this.state.remoteUrl,
          onChange: this.onRemoteUrlChange.bind(this),
          className: Styles.urlInputTextBox,
          type: "text",
          placeholder: "e.g. http://data.gov.au/geoserver/wms"
        }), /*#__PURE__*/_jsx("button", {
          disabled: this.state.remoteUrl.length === 0,
          type: "submit",
          onClick: this.handleUrl.bind(this),
          className: Styles.urlInputBtn,
          children: t("addData.urlInputBtn")
        }), this.state.isLoading && /*#__PURE__*/_jsx(Loader, {})]
      })]
    });
  }
  render() {
    return /*#__PURE__*/_jsx("div", {
      className: Styles.inner,
      children: this.renderPanels()
    });
  }
}, _defineProperty(_AddData, "propTypes", {
  terria: PropTypes.object,
  viewState: PropTypes.object,
  resetTab: PropTypes.func,
  activeTab: PropTypes.string,
  // localDataTypes & remoteDataTypes specifies the file types to show in dropdowns for local and remote data uploads.
  // These default to the lists defined in getDataType.ts
  // Some external components use these props to customize the types shown.
  localDataTypes: PropTypes.arrayOf(PropTypes.object),
  remoteDataTypes: PropTypes.arrayOf(PropTypes.object),
  onFileAddFinished: PropTypes.func.isRequired,
  onUrlAddFinished: PropTypes.func.isRequired,
  t: PropTypes.func.isRequired
}), _AddData)) || _class;
/**
 * @param extensions - string[]
 * @returns Comma separated string of extensions
 */
function buildExtensionsList(extensions) {
  return extensions.map(ext => ".".concat(ext)).join(", ");
}
export default withTranslation()(AddData);